///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2025
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useRef } from "react";
import Tippy from "@tippyjs/react";

function DropdownForGrid({
  inputId,
  value,
  staticOptions,
  handleChange,
  onFocus,
  onBlur,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  const DropdownContent = () => {
    return (
      <div className="dropdown">
        {staticOptions.map(option => (
          <div
            key={option.value}
            className="dropdown-option"
            onMouseDown={e => {
              e.preventDefault();
              handleChange(option);
              setIsOpen(false);
              inputRef.current?.blur();
            }}
          >
            {option.label}
          </div>
        ))}
      </div>
    );
  };

  const handleInputClick = e => {
    setIsOpen(prevState => !prevState);
    onFocus(e);
  };

  const handleBlur = e => {
    if (!e.relatedTarget || !inputRef.current.contains(e.relatedTarget)) {
      setIsOpen(false);
      onBlur && onBlur(e);
    }
  };

  return (
    <Tippy
      visible={isOpen}
      arrow={false}
      content={<DropdownContent />}
      delay={0}
      duration={0}
      interactive
      placement="bottom-start"
      touch="hold"
      trigger={undefined}
      appendTo="parent"
      offset={[0, 0]}
      onClickOutside={() => setIsOpen(false)}
    >
      <input
        id={inputId}
        ref={inputRef}
        type="text"
        className="dropdown-input"
        value={value?.label || ""}
        onBlur={handleBlur}
        onFocus={handleInputClick}
        readOnly
        {...props}
      />
    </Tippy>
  );
}

export default DropdownForGrid;
